var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TablePrice',{attrs:{"data_key":_vm.price_type,"prices":_vm.data_table},on:{"update:showModalCreatePrice":function($event){return _vm.onShowModalCreatePrice()}}}),_c('ModalCreatePrice',{ref:"modalCreatePrice",on:{"success":_vm.getUserPrice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }